import styled from 'styled-components';

export const ButtonContainer = styled.div`
  flex-direction: row;
  display: flex;
  padding-top: 5px;
`;
export const Spacer = styled.div`
  width: 5px;
`;
